import React from "react"

import ExpensesTableRow from "../ExpensesTableRow"
import { calculatePhaseTotalOtherExpenses } from "../projectBudgetHelpers"
import { ExpenseTotals } from "../types"

type Props = {
  phaseId: number
  expenses: ExpenseTotals[]
}

const PhaseOtherExpensesRow: React.FC<Props> = (props) => {
  const { phaseId, expenses } = props

  const totalExpenses = calculatePhaseTotalOtherExpenses(expenses)

  return (
    <ExpensesTableRow
      label="Other Expenses"
      value={totalExpenses}
      canDelete={false}
      deleteTooltip="You can remove expenses from the 'Other Expenses' tab"
      dataTest={`phase-${phaseId}-expenses`}
      allowEdit={false}
    />
  )
}

export default PhaseOtherExpensesRow
